// extracted by mini-css-extract-plugin
module.exports = {"catList":"categories__catList","cat":"categories__cat","catLink":"categories__catLink","catLinkSelected":"categories__catLinkSelected"};